import { Product, selectors } from '@uds/product';

import { PricingStrategy } from './constants';

const { getInterval } = selectors;

export const getDisplayPeriod = ({
  product,
  pricingStrategy,
}: {
  product: Product;
  pricingStrategy: PricingStrategy;
}) => {
  const givenInterval = pricingStrategy?.paymentIntervalDisplay;
  const productInterval = getInterval({ product });
  return givenInterval ?? productInterval;
};
export default null;
